'use client';
import type { CSSProperties, ReactNode } from 'react';
import { useV4Enter } from '@/hooks/useV4Enter';

/**
 * Thin client-side wrapper that attaches a useV4Enter ref to a container.
 * Use from server components (e.g. async PricingSection) that cannot hold
 * React refs directly.
 */
export function V4EnterGrid({
  children,
  className = '',
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  const ref = useV4Enter();
  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  );
}
